.main {
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
}

.commentInput {
	width: 100%;
	max-width: 34rem;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-end;
}

.textarea {
	background-color: var(--depth1);
}

.commentSection {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
	max-width: 34rem;
	left: 5%;
}
.commentSection > p {
	width: 100%;
	position: relative;
}
.commentSection > p::before {
	position: absolute;
	top: 100%;
	background-color: var(--depth3);
	content: '';
	height: 2px;
	width: 100%;
}
@media screen and (max-width: 768px) {
	.commentInput {
		align-items: center;
	}
}
